import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../interface/component/injected-props.interface';
import { getTranslation } from '../../util/translation/get-translation';
import { Ellipsis, IEllipsisProps } from '../ellipsis';

interface ITranslateProps extends IEllipsisProps {
  props?: {
    [ key: string ]: string;
  } | string[];
}

@inject('state')
@observer
export default class Translate extends React.Component<ITranslateProps & IInjectedProps> {
  render() {
    const translationProps = this.props.props;
    const translationKey = this.props.children;
    const translation = getTranslation(this.props.state.configuration, translationKey, translationProps);
    return <Ellipsis
      isEllipsis={this.props.isEllipsis === undefined || this.props.isEllipsis}
      onClick={this.props.onClick}
      style={this.props.style}
      data-translation-key={translationKey}
      title={translation}
    >
      {translation}
    </Ellipsis>;
  }
}
